import React, { FC, ReactElement } from 'react'
import styles from './InscriptionActionInput.module.css'
import classNames from 'classnames'
import Input from '@/components/input'

const InscriptionActionInput: FC<{
	placeholder: string
	value: string
	onChange: (evt: any) => void
	error?: boolean
	endAdornment?: string | ReactElement
}> = (props): ReactElement => {
	return (
		<Input
			className={classNames("text-sm rounded-full border border-border", { [styles.error]: props.error })}
			inputClassName="text-sm rounded-l-full"
			placeholder={props.placeholder}
			value={props.value}
			onChange={props.onChange}
			endAdornmentClassName="rounded-r-full"
			endAdornment={props?.endAdornment}
		/>
	)
}

export default InscriptionActionInput
